<template>
  <b-navbar id="top-header" ref="topHeader" fixed="top" type="primary" variant="white" class="d-none d-md-block">
    <b-container class="h-100">

      <b-navbar-brand href="/">
        <img :src="$getConst.images.logo_default" height="40" alt="hays logo">
      </b-navbar-brand>
      <ProfileDropdown  v-if="!isMobileView"/>
    </b-container>
  </b-navbar>
</template>

<script>
  import ProfileDropdown from "./ProfileDropdown";

  export default {
    name: "TopHeader",
    components: {ProfileDropdown},
    props: {
      isMobileView: {
        type: Boolean,
        default: false
      },
    }
  }
</script>

<style scoped>

</style>
